const mapClientContactPeopleToOptions = contactPeople =>
    contactPeople.map(contactPerson => ({
        value: contactPerson.id,
        label: contactPerson.name,
    }));

export default mapClientContactPeopleToOptions;
